<template>
  <div id="loadingWrap" v-if="loading">
    <ring-loader :loading="loading"></ring-loader>
  </div>
</template>

<script>
  import RingLoader from "vue-spinner/src/RingLoader";
  export default {
    name: "loading",
    components: {
      RingLoader
    },
    props: [],
    computed: {},
    watch: {},
    methods: {},
    data() {
      return {
        loading : true ,
      }
    },
    created() {

    },
    updated() {

    },
    mounted() {

    },


  }
</script>

<style scoped lang="scss">
  #loadingWrap {
    position: absolute;
    width:100%;
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:9999;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/layouts/Loading.vue